// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d63126e","239":"7d946f0d","553":"da7b937d"}[chunkId] + ".chunk.js";
};